import Image from 'global/Image';
import { BannerContainer, LivePlayerButton, PlayerBannerContainer } from './styled';

interface PlayerBannerProps {
  image: 'string';
  isCanPlay: boolean;
  onPlay: () => void;
}

function PlayerBanner({ image, isCanPlay, onPlay }: PlayerBannerProps) {
  if (isCanPlay) {
    return (
      <PlayerBannerContainer id="livestream-banner-container">
        <Image src={image} alt="banner" id="livestream-banner-image-cover" />
        <BannerContainer>
          <LivePlayerButton
            onClick={onPlay}
            id="livestream-banner-play-button"
          >
            <Image src="/icon/play-youtube.svg" />
          </LivePlayerButton>
        </BannerContainer>
      </PlayerBannerContainer>
    );
  }

  return (
    <PlayerBannerContainer id="livestream-banner-container">
      <Image src={image} alt="banner" id="livestream-banner-image-cover" />
    </PlayerBannerContainer>
  );
}

export default PlayerBanner;
